/*
Defines the custom element <ravel-dock>
*/

import { RavelDock } from './src/RavelDock.js';

customElements.define('ravel-dock', RavelDock);
